module.exports = __webpack_public_path__ + "img/banner_iv2.f3848af9.png";